'use strict';

var _ = require('lodash');
var d3 = require('d3');
var drawUtils = require('../utils/drawUtils');

var categoryColumn = {};

categoryColumn.updateColumn = function (_g, data, tweenTime, showToolTip, toolTipPosition, removeToolTip, updateFilterSelection, onDragAllowed) {

  categoryColumn.data = data;
  categoryColumn.relationProps = {
    source: {},
    target: {}
  };

  var categories = _g.selectAll('#gCategory').data(data.dataCategories, function (d) {
    return d.category;
  });

  categories.enter().append('g').attr('id', 'gCategory').attr('key', function (d) {
    return d.category;
  }).each(function (d, i) {

    var g = d3.select(this);
    d.style = categoryColumn.getColumnStyleProps(d);

    g.append('rect').attr('id', 'bar-default').attr('x', -data.column.width / 2).attr('y', d.y).attr('width', data.column.width).attr('height', d.height).attr('fill', d.style.fill).attr('opacity', d.style.opacity).attr('stroke', '#fff').attr('stroke-width', d.style.strokeWidth).attr('cursor', 'pointer');

    g.append('rect').attr('id', 'bar-similar').attr('x', -(data.column.width / 2) + 1).attr('y', d.yMean - d.heightSimilar / 2).attr('width', data.column.width - 2).attr('height', d.heightSimilar).attr('fill', d.style.fill).attr('stroke', '#fff').attr('stroke-width', 0.1).attr('stroke', 'none').attr('cursor', 'pointer');

    var opacity = 0.9;
    var textShadow = 'none';
    // if(d.percentage <= 0.075){
    //   opacity=0;
    //   textShadow='0 1px 0 #fff, 1px 0 0 #fff, 0 -1px 0 #fff, -1px 0 0 #fff';
    // }

    // label and metrics
    var bckgrLabel = g.append('rect');
    bckgrLabel.attr('id', 'bckgr-label').attr('height', 18).attr('rx', 3).attr('ry', 3).attr('fill', '#fff').attr('opacity', opacity);

    var textNodeLabel = g.append('text');
    textNodeLabel.attr('id', 'label').attr('class', 'pp-svg-axis-label').attr('text-anchor', 'end').attr('x', -data.column.width).style('text-shadow', textShadow);

    var bckgrMetric = g.append('rect');
    bckgrMetric.attr('id', 'bckgr-metric').attr('height', 18).attr('rx', 3).attr('ry', 3).attr('fill', '#fff').attr('opacity', opacity);

    var textNodeMetric = g.append('text');
    textNodeMetric.attr('id', 'metric').attr('class', 'pp-svg-axis-label').attr('x', data.column.width).style('text-shadow', textShadow);

    categoryColumn.setLabelProps(d, textNodeLabel, bckgrLabel, textNodeMetric, bckgrMetric);

    g.append('rect').attr('id', 'bar-mouse-overlay').attr('x', -data.column.width / 2).attr('y', d.y).attr('width', data.column.width).attr('height', d.height).attr('opacity', 0).attr('cursor', 'pointer').on("mouseover", function () {
      onDragAllowed = false;
      g.select("#bar-default").attr('opacity', 0.75);
      g.select("#bar-default").attr('fill', drawUtils.colors.similarPatients.filter);
      showToolTip(d, null);
    }).on("mouseout", function () {
      onDragAllowed = true;
      g.select("#bar-default").attr('opacity', d.style.opacity);
      g.select("#bar-default").attr('fill', d.style.fill);
      removeToolTip();
    }).on("click", function () {
      updateFilterSelection([d], tweenTime);
      onDragAllowed = false;
    }).on("mousemove", function () {
      toolTipPosition();
    });
  });

  categories.each(function (d) {
    var g = d3.select(this);

    d.style = categoryColumn.getColumnStyleProps(d);

    g.select('#bar-default').transition().duration(tweenTime).attr('y', d.y).attr('height', d.height).attr('fill', d.style.fill).attr('opacity', d.style.opacity);

    g.select('#bar-similar').attr('width', data.column.width - 2).transition().duration(500).attr('height', d.heightSimilar).attr('y', d.yMean - d.heightSimilar / 2);

    g.select('#bar-mouse-overlay').attr('y', d.y).attr('height', d.height);

    var textNodeLabel = g.select('#label');
    var bckgrLabel = g.select('bckgr-label');
    var textNodeMetric = g.select('#metric');
    var bckgrMetric = g.select('#bckgr-metric');

    categoryColumn.setLabelProps(d, textNodeLabel, bckgrLabel, textNodeMetric, bckgrMetric);
  });

  categories.exit().remove();
};

categoryColumn.setLabelProps = function (d, textNodeLabel, bckgrLabel, textNodeMetric, bckgrMetric) {

  var columnWidth = categoryColumn.data.column.width;

  textNodeLabel.attr('y', d.labelPosY + 2).text(d.label);
  var wLabel = categoryColumn.getComputedLength(textNodeLabel);

  bckgrLabel.attr('x', -columnWidth - wLabel + 6).attr('y', d.labelPosY - 9).attr('width', wLabel);

  textNodeMetric.attr('y', d.labelPosY + 2).text(d.metricLabel);
  var wMetric = categoryColumn.getComputedLength(textNodeMetric);

  bckgrMetric.attr('x', columnWidth - 6).attr('y', d.labelPosY - 9).attr('width', wMetric);
};

categoryColumn.getComputedLength = function (textNode) {
  var bbox = textNode.node().getBBox();
  return bbox.width + 12;
};

categoryColumn.updateSankeyRelations = function (_g, cat, catIndex, bandwidth, tweenTime) {

  if (catIndex === 0) {
    categoryColumn.relationProps.source = {};
    categoryColumn.relationProps.target = {};
  }

  var svgSpline = d3.line().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  });
  //.curve(d3.curveMonotoneX)

  _.each(cat.relations, function (rel, i) {

    if (!categoryColumn.relationProps.source[rel.source.category]) categoryColumn.relationProps.source[rel.source.category] = rel.source.baseY;
    if (!categoryColumn.relationProps.target[rel.target.category]) categoryColumn.relationProps.target[rel.target.category] = rel.target.baseY;

    var vertex0 = void 0,
        vertex1 = void 0,
        vertex2 = void 0,
        vertex3 = void 0;

    var sourceY = categoryColumn.relationProps.source[rel.source.category];
    vertex0 = { x: rel.offsetX, y: sourceY };
    vertex1 = { x: rel.offsetX, y: sourceY + rel.source.height };

    categoryColumn.relationProps.source[rel.source.category] += rel.source.height;

    //targets
    var targetY = categoryColumn.relationProps.target[rel.target.category];
    vertex2 = { x: rel.offsetX - bandwidth, y: targetY + rel.target.height };
    vertex3 = { x: rel.offsetX - bandwidth, y: targetY };

    categoryColumn.relationProps.target[rel.target.category] += rel.target.height;

    rel.path = [vertex0, vertex1, vertex2, vertex3];
  });

  var areas = _g.selectAll('#relationArea_' + catIndex).data(cat.relations);

  areas.enter().append('path').attr('id', 'relationArea_' + catIndex).attr('d', function (d) {
    return svgSpline(d.path);
  }).attr('fill', drawUtils.colors.similarPatients.default)
  //.attr('stroke', '#fff')
  .attr('fill-opacity', 0.25);

  areas.transition().duration(tweenTime).attr('d', function (d) {
    return svgSpline(d.path);
  });

  areas.exit().remove();
};

categoryColumn.getColumnStyleProps = function (d) {

  var style = {};
  style.strokeWidth = 2;
  if (d.height < 2) style.strokeWidth = 1;

  style.fill = drawUtils.colors.similarPatients.default;
  style.opacity = 1;

  if (d.filtersActive) style.opacity = 0.25;
  style.fillSelected = drawUtils.colors.similarPatients.filter;

  if (d.selected) {
    style.fill = drawUtils.colors.similarPatients.filter;
    style.opacity = 0.5;
  }

  if (d.filtersActive && d.similarCount === 0) style.fill = '#666';

  if (d.category === 'NA' || d.category === 'Missing') style.fill = drawUtils.colors.similarPatients.deSelected;

  return style;
};

module.exports = categoryColumn;